import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowStep} from "../workflow-step";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {WorkflowService} from "../workflow.service";
import {DeviceDefectWorkflowService} from "./device-defect-workflow.service";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DefectAssetBundleModel} from "./defect-asset-bundle.model";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {toggleLoading} from "../../misc/loading.decorator";

@Component({
  templateUrl: "./select-bundle-parts.template.pug",
  providers: [
    DeviceDefectWorkflowService,
    DialogService,
  ],
})

export class SelectBundlePartsComponent extends WorkflowStep {
  deviceDefectId: string;
  error: Error;
  assets: DefectAssetBundleModel[] = [];

  disableStep: boolean;

  @toggleLoading()
  @handleErrors()
  async ready(): Promise<void> {
    this.deviceDefectId = this.workflowService.workflowConfig.targetId;
    const {assets, closed} = await this.deviceDefectWorkflowService.getDefectAssets(this.deviceDefectId);
    this.assets = assets;
    this.disableStep = closed;
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    private deviceDefectWorkflowService: DeviceDefectWorkflowService,
    public dialogService: DialogService,
  ) {
    super();
    this.saveOnContinue = true;
  }

  @handleErrors()
  async autoSave(): Promise<boolean> {
    await this.deviceDefectWorkflowService.saveBundlePartSelections(this.deviceDefectId, this.assets);

    await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);

    return true;
  }
}
